(function () {
  'use strict';

  var DEBUG = false;
  function log() { if (DEBUG) { var a = Array.prototype.slice.call(arguments); a.unshift('[GFC]'); console.log.apply(console, a); } }

  function init() {
    var allConfigs = window.gfcKit || {};
    log('init — configs found:', Object.keys(allConfigs).length);
    Object.keys(allConfigs).forEach(function (sectionId) {
      setup(allConfigs[sectionId]);
    });
  }

  function setup(cfg) {
    var section = document.querySelector('.gfc-kit[data-section-id="' + cfg.sectionId + '"]');
    if (!section) { log('setup — section DOM not found for', cfg.sectionId); return; }
    log('setup —', cfg.sectionId, '| kits:', {
      base: { id: cfg.kits.base?.id, handle: cfg.kits.base?.handle, images: cfg.kits.base?.images?.length },
      custom: { id: cfg.kits.custom?.id, handle: cfg.kits.custom?.handle, images: cfg.kits.custom?.images?.length },
      player: { id: cfg.kits.player?.id, handle: cfg.kits.player?.handle, images: cfg.kits.player?.images?.length }
    });

    var state = {
      size: '',
      mode: 'none', // none | custom | player
      badge: 'none',
      badgePrice: 0,
      playerName: '',
      playerNumber: '',
      backId: '',
      playerPhoto: '',
      linkedProduct: null,
      badgeLinkedProduct: null,
      customName: '',
      customNumber: ''
    };

    var els = {
      title: section.querySelector('#gfc-title'),
      sizes: section.querySelectorAll('input[name="gfc-size"]'),
      tabs: section.querySelectorAll('.gfc-kit__tab'),
      panels: section.querySelectorAll('.gfc-kit__panel'),
      playerSelect: section.querySelector('#gfc-player'),
      customName: section.querySelector('#gfc-custom-name'),
      customNumber: section.querySelector('#gfc-custom-number'),
      badges: section.querySelectorAll('input[name="gfc-badge"]'),
      price: section.querySelector('#gfc-price'),
      subtotal: section.querySelector('#gfc-subtotal'),
      atc: section.querySelector('#gfc-atc'),
      atcText: section.querySelector('#gfc-atc-text'),
      variantInput: section.querySelector('#gfc-variant-id'),
      propSize: section.querySelector('#gfc-prop-size'),
      propMode: section.querySelector('#gfc-prop-mode'),
      propName: section.querySelector('#gfc-prop-name'),
      propNumber: section.querySelector('#gfc-prop-number'),
      propBack: section.querySelector('#gfc-prop-back'),
      propBadge: section.querySelector('#gfc-prop-badge'),
      thumbsContainer: section.querySelector('#gfc-thumbs'),
      slidesContainer: section.querySelector('#gfc-slides'),
      navPrev: section.querySelector('.gfc-kit__nav--prev'),
      navNext: section.querySelector('.gfc-kit__nav--next'),
      canvas: section.querySelector('#gfc-canvas'),
      canvasBase: section.querySelector('#gfc-canvas-base'),
      form: section.querySelector('#gfc-form'),
      sentinel: section.querySelector('#gfc-form-sentinel')
    };

    var baseTitle = els.title ? els.title.dataset.baseTitle || els.title.textContent.trim() : '';
    var lastKitId = null;

    function formatMoney(cents) {
      try {
        return new Intl.NumberFormat(cfg.locale || 'es-ES', {
          style: 'currency',
          currency: cfg.currency || 'EUR'
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + (cfg.currency || 'EUR');
      }
    }

    function currentKit() {
      // 1) Combo player+badge → highest priority
      if (state.mode === 'player' && state.playerName && state.badge !== 'none' && cfg.combos) {
        var key = state.playerName.toUpperCase() + '|' + state.badge.toLowerCase();
        if (cfg.combos[key]) return cfg.combos[key];
      }
      // 2) Player linked product
      if (state.mode === 'player' && state.linkedProduct) return state.linkedProduct;
      // 3) Badge linked product (when no player linked)
      if (state.badgeLinkedProduct) return state.badgeLinkedProduct;
      // 4) Default kits
      if (state.mode === 'custom') return cfg.kits.custom;
      if (state.mode === 'player') return cfg.kits.player;
      return cfg.kits.base;
    }

    function findVariant(kit, size) {
      var idx = cfg.sizeOptionIndex;
      var key = idx === 0 ? 'option1' : idx === 1 ? 'option2' : 'option3';
      for (var i = 0; i < kit.variants.length; i++) {
        if (kit.variants[i][key] === size) return kit.variants[i];
      }
      return null; // no match — caller must handle
    }
    function firstAvailableVariant(kit) {
      for (var i = 0; i < kit.variants.length; i++) {
        if (kit.variants[i].available) return kit.variants[i];
      }
      return kit.variants[0] || null;
    }

    function readSize() {
      for (var i = 0; i < els.sizes.length; i++) if (els.sizes[i].checked) return els.sizes[i].value;
      return '';
    }

    function updateSizeAvailability() {
      var kit = currentKit();
      var idx = cfg.sizeOptionIndex;
      var key = idx === 0 ? 'option1' : idx === 1 ? 'option2' : 'option3';
      els.sizes.forEach(function (input) {
        var match = kit.variants.find(function (v) { return v[key] === input.value; });
        input.disabled = !match || !match.available;
      });
    }

    function preloadImage(url) {
      return new Promise(function (resolve) {
        if (!url) return resolve();
        var img = new Image();
        img.onload = img.onerror = function () { resolve(); };
        img.src = url;
      });
    }

    function swapKitGallery(kit) {
      log('swapKitGallery — kit:', { id: kit.id, handle: kit.handle, images: kit.images?.length, lastKitId });
      if (!els.thumbsContainer || !els.slidesContainer) return;
      if (!kit.images || !kit.images.length) return;
      if (lastKitId === kit.id) return;
      lastKitId = kit.id;

      // Preload first image BEFORE swapping DOM. Old gallery stays visible
      // until the new primary image is ready, then cross-fade.
      preloadImage(kit.images[0].url).then(function () {
        rebuildGalleryDom(kit);
      });
    }

    function rebuildGalleryDom(kit) {
      if (lastKitId !== kit.id) return; // user switched again while loading

      // Preserve customize thumb and slide if they exist
      var customizeThumb = els.thumbsContainer.querySelector('.gfc-kit__thumb--customize');
      var customizeSlide = els.slidesContainer.querySelector('.gfc-kit__slide--customize');

      // Rebuild thumbs
      els.thumbsContainer.innerHTML = '';
      kit.images.forEach(function (img, idx) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gfc-kit__thumb' + (idx === 0 ? ' is-active' : '');
        btn.dataset.thumbIndex = String(idx);
        btn.setAttribute('aria-label', 'Imagen ' + (idx + 1));
        btn.innerHTML = '<img class="gfc-kit__thumb-img" src="' + img.thumb + '" alt="' + (img.alt || '') + '" loading="lazy">';
        els.thumbsContainer.appendChild(btn);
      });
      if (customizeThumb) els.thumbsContainer.appendChild(customizeThumb);

      // Rebuild slides with fade-in
      els.slidesContainer.innerHTML = '';
      kit.images.forEach(function (img, idx) {
        var div = document.createElement('div');
        div.className = 'gfc-kit__slide' + (idx === 0 ? ' is-active gfc-kit__slide--fade' : '');
        div.dataset.slideIndex = String(idx);
        div.innerHTML = '<img class="gfc-kit__slide-img" src="' + img.url + '" alt="' + (img.alt || '') + '" loading="lazy">';
        els.slidesContainer.appendChild(div);
      });
      if (customizeSlide) {
        els.slidesContainer.appendChild(customizeSlide);
        // Base del slide de personalización = cara TRASERA / foto del jugador (NO la 1ª foto del
        // producto). rebuildGalleryDom es async (corre tras un preload) y antes pisaba la base
        // con kit.images[0] tras updateCustomizeBase → "la última foto se repetía". Ahora delega.
        updateCustomizeBase(kit);
      }

      // Re-bind thumb click
      els.thumbsContainer.querySelectorAll('.gfc-kit__thumb').forEach(function (t) {
        t.addEventListener('click', function () { gotoSlide(t.dataset.thumbIndex); });
      });
      currentImageIdx = 0;
    }

    function updateTitle() {
      if (!els.title) return;
      // Linked product → use its title verbatim (no suffix, it already names the player)
      if (state.linkedProduct && state.linkedProduct.title) {
        els.title.textContent = state.linkedProduct.title;
        return;
      }
      var name = state.mode === 'player' ? state.playerName : state.mode === 'custom' ? state.customName : '';
      var num = state.mode === 'player' ? state.playerNumber : state.mode === 'custom' ? state.customNumber : '';
      var suffix = '';
      if (name && num) suffix = ' — ' + name + ' ' + num;
      else if (name) suffix = ' — ' + name;
      els.title.textContent = baseTitle + suffix;
    }

    function update() {
      state.size = readSize();
      var kit = currentKit();
      var variant = findVariant(kit, state.size);
      // Fallback SOLO si ya había una talla elegida que no existe en este kit (p.ej. al cambiar
      // de equipació). Si NO hay talla elegida, no la seleccionamos por el cliente (sin preselección).
      if (!variant && state.size) {
        var fb = firstAvailableVariant(kit);
        if (fb) {
          var idx = cfg.sizeOptionIndex;
          var key = idx === 0 ? 'option1' : idx === 1 ? 'option2' : 'option3';
          state.size = fb[key];
          // sync radio
          els.sizes.forEach(function (i) { i.checked = i.value === state.size; });
          variant = fb;
          showSizeFallbackHint(state.size);
        }
      }
      log('update — mode:', state.mode, '| kit:', { id: kit?.id, handle: kit?.handle }, '| variant:', { id: variant?.id, size: state.size, price: variant?.price });

      // Defensive: if still no variant, disable ATC and bail on price/url updates
      if (!variant) {
        els.atc.disabled = true;
        els.atcText.textContent = state.size ? 'No disponible' : 'Tria una talla';
        els.variantInput.value = '';
        swapKitGallery(kit);
        updateCustomizeBase(kit);
        updateTitle();
        updateSizeAvailability();
        return;
      }

      els.variantInput.value = variant.id;
      els.propSize.value = state.size;
      els.propMode.value = MODE_LABELS[state.mode] || state.mode;
      els.propBadge.value = state.badge === 'none' ? 'Sin parche' : state.badge;

      if (state.mode === 'player') {
        els.propName.value = state.playerName;
        els.propNumber.value = state.playerNumber;
        els.propBack.value = state.backId;
      } else if (state.mode === 'custom') {
        els.propName.value = state.customName;
        els.propNumber.value = state.customNumber;
        els.propBack.value = '';
      } else {
        els.propName.value = '';
        els.propNumber.value = '';
        els.propBack.value = '';
      }

      var basePrice = variant.price;
      var total = basePrice + state.badgePrice;
      // Recargo de personalització (nom/dorsal): aplica cuando HAY personalización real
      // (jugador elegido en player, o nombre+dorsal en custom). Coincide con la línea fee
      // que se cobra al añadir. Así el tab player activo sin jugador NO cobra de más.
      var hasPersonalization = (state.mode === 'player' && state.playerName) || (state.mode === 'custom' && (state.customName || state.customNumber));
      if (hasPersonalization) {
        total += cfg.customSurcharge;
      }

      // El preu mostrat inclou recàrrecs (estampació + pegat), com a home.
      els.price.textContent = formatMoney(total);
      els.price.dataset.basePrice = basePrice;
      els.subtotal.textContent = formatMoney(total);

      var available = variant.available;
      els.atc.disabled = !available;
      els.atcText.textContent = available ? cfg.atcText : cfg.soldOutText;

      swapKitGallery(kit);
      updateCustomizeBase(kit);
      updateTitle();
      updateSizeAvailability();
      redrawCanvas();
      updateUrl(kit, variant);
      updateSchemaJsonLd(kit, variant);
    }

    var MODE_LABELS = { none: 'Sin personalización', player: 'Jugador', custom: 'Tu nombre' };

    var _hintTimer = null;
    function showSizeFallbackHint(newSize) {
      var existing = section.querySelector('.gfc-kit__hint');
      if (existing) existing.remove();
      var hint = document.createElement('div');
      hint.className = 'gfc-kit__hint';
      hint.textContent = 'Talla cambiada a ' + newSize + ' (no disponible en esta camiseta).';
      var sizesField = section.querySelector('.gfc-kit__sizes');
      if (sizesField) sizesField.appendChild(hint);
      clearTimeout(_hintTimer);
      _hintTimer = setTimeout(function () { hint.remove(); }, 3000);
    }

    function updateCustomizeBase(kit) {
      if (!els.canvasBase) { log('updateCustomizeBase — canvasBase missing'); return; }
      var badge = section.querySelector('input[name="gfc-badge"]:checked');
      var badgePhoto = badge ? badge.dataset.jerseyPhoto : '';
      // Tecnología home: dibujar siempre sobre la TRASERA del propio producto (data-back).
      // Si está definida, manda sobre fotos de jugador/badge (no swap de producto).
      // Trasera según parche: con pegat (LaLiga) usa data-back-laliga; sin parche, data-back.
      var isBadge = state.badge && state.badge !== 'none';
      var backLaliga = (els.canvas && els.canvas.dataset.backLaliga) || '';
      var back = (isBadge && backLaliga) ? backLaliga : ((els.canvas && els.canvas.dataset.back) || '');
      var customBack = (state.mode === 'custom' && cfg.customBackPhoto) ? cfg.customBackPhoto : '';
      var url = back || customBack || state.playerPhoto || badgePhoto || (kit.images && kit.images[0] ? kit.images[0].url : '');
      log('updateCustomizeBase —', { playerPhoto: state.playerPhoto, badgePhoto: badgePhoto, customBack: customBack, kitFirst: kit.images?.[0]?.url, chosen: url, currentSrc: els.canvasBase.src });
      if (url && els.canvasBase.src !== url) {
        // Preload off-screen, then swap src + redraw. Old image visible meanwhile.
        var preload = new Image();
        preload.onload = preload.onerror = function () {
          els.canvasBase.removeAttribute('srcset');
          els.canvasBase.src = url;
          els.canvasBase.addEventListener('load', redrawCanvas, { once: true });
          if (els.canvasBase.complete) redrawCanvas();
        };
        preload.src = url;
      }
    }

    function updateUrl(kit, variant) {
      try {
        if (!window.history || !window.history.replaceState) return;
        var variantNum = (variant.id || '').toString().split('/').pop();
        var qs = ['variant=' + variantNum];
        // Share URL extras: name, number, badge
        if (state.mode === 'custom') {
          if (state.customName) qs.push('n=' + encodeURIComponent(state.customName));
          if (state.customNumber) qs.push('num=' + encodeURIComponent(state.customNumber));
        }
        if (state.badge && state.badge !== 'none') qs.push('badge=' + encodeURIComponent(state.badge));
        var url = '/products/' + kit.handle + '?' + qs.join('&');
        if (location.pathname + location.search !== url) {
          window.history.replaceState({}, '', url);
        }
      } catch (e) {}
    }

    function updateSchemaJsonLd(kit, variant) {
      // Swap product schema.org JSON-LD on kit change so search engines/Google
      // Merchant see the active product, not the original page product.
      try {
        var existing = document.querySelector('script[type="application/ld+json"][data-gfc-kit]');
        if (existing) existing.remove();
        var payload = {
          '@context': 'https://schema.org/',
          '@type': 'Product',
          name: kit.title,
          url: location.origin + '/products/' + kit.handle,
          offers: {
            '@type': 'Offer',
            price: (variant.price / 100).toFixed(2),
            priceCurrency: cfg.currency || 'EUR',
            availability: variant.available ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
            url: location.origin + '/products/' + kit.handle + '?variant=' + (variant.id || '').toString().split('/').pop()
          }
        };
        if (kit.images && kit.images[0]) payload.image = (kit.images[0].url.startsWith('//') ? location.protocol : '') + kit.images[0].url;
        var s = document.createElement('script');
        s.type = 'application/ld+json';
        s.setAttribute('data-gfc-kit', '1');
        s.textContent = JSON.stringify(payload);
        document.head.appendChild(s);
        // Also swap canonical
        var canonical = document.querySelector('link[rel="canonical"]');
        if (canonical) canonical.href = location.origin + '/products/' + kit.handle;
        // og:url + og:title
        var ogUrl = document.querySelector('meta[property="og:url"]');
        if (ogUrl) ogUrl.setAttribute('content', location.origin + '/products/' + kit.handle);
        var ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) ogTitle.setAttribute('content', kit.title);
      } catch (e) {}
    }

    // Tabs
    els.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        log('tab click →', tab.dataset.tab);
        els.tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        var target = tab.dataset.tab;
        els.panels.forEach(function (p) { p.hidden = p.dataset.panel !== target; });
        state.mode = target;
        if (target !== 'player') { state.playerName = ''; state.playerNumber = ''; state.backId = ''; state.playerPhoto = ''; state.linkedProduct = null; }
        if (target !== 'custom') { state.customName = ''; state.customNumber = ''; }
        // Reset badge when going back to 'none' (clean slate)
        if (target === 'none') {
          state.badge = 'none';
          state.badgePrice = 0;
          state.badgeLinkedProduct = null;
          var noneRadio = section.querySelector('input[name="gfc-badge"][value="none"]');
          if (noneRadio) noneRadio.checked = true;
        }
        if (target === 'custom' || target === 'player') {
          gotoSlide('customize');
        } else {
          gotoSlide(0);
          currentImageIdx = 0;
        }
        update();
      });
    });

    // Sizes
    els.sizes.forEach(function (input) {
      input.addEventListener('change', update);
    });

    // Badges
    els.badges.forEach(function (input) {
      input.addEventListener('change', function () {
        state.badge = input.value;
        state.badgePrice = parseInt(input.dataset.price, 10) || 0;
        // Parse badge linked product if present
        var blinked = null;
        if (input.dataset.linked) {
          try { blinked = JSON.parse(input.dataset.linked); } catch (e) { blinked = null; }
        }
        state.badgeLinkedProduct = blinked;
        if (input.value !== 'none') gotoSlide('customize');
        update();
      });
    });

    // Lazy combo data: fetch /products/{handle}.js on demand and cache
    var _kitCache = {};
    function fetchKitByHandle(handle) {
      if (_kitCache[handle]) return Promise.resolve(_kitCache[handle]);
      return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return null;
          var kit = {
            id: p.id, handle: p.handle, title: p.title, price: p.price,
            images: (p.media || p.images || []).map(function (m) {
              var url = (m.preview_image && m.preview_image.src) || m.src;
              return { url: url, thumb: url, alt: p.title };
            }),
            variants: p.variants.map(function (v) {
              return { id: v.id, option1: v.option1, option2: v.option2, option3: v.option3, price: v.price, available: v.available };
            })
          };
          _kitCache[handle] = kit;
          return kit;
        });
    }

    // Player
    if (els.playerSelect) {
      els.playerSelect.addEventListener('change', function () {
        els.playerSelect.classList.remove('is-error');
        state.mode = 'player';
        var opt = els.playerSelect.options[els.playerSelect.selectedIndex];
        state.playerName = opt.value;
        state.playerNumber = opt.dataset.number || '';
        state.backId = opt.dataset.backId || '';
        state.playerPhoto = opt.dataset.photo || '';
        if (opt.value) gotoSlide('customize');
        var linked = null;
        if (opt.dataset.linked) {
          try { linked = JSON.parse(opt.dataset.linked); } catch (e) { linked = null; }
        }
        // Lazy: if no inline linked data but linkedHandle attr present, fetch live
        if (!linked && opt.dataset.linkedHandle) {
          fetchKitByHandle(opt.dataset.linkedHandle).then(function (kit) {
            state.linkedProduct = kit;
            update();
          });
          return; // first update happens in callback
        }
        state.linkedProduct = linked;
        update();
      });
      // Image preload on hover/focus of options (prefetch)
      Array.from(els.playerSelect.options).forEach(function (o) {
        if (!o.dataset.linked) return;
        try {
          var data = JSON.parse(o.dataset.linked);
          if (data.images && data.images[0]) {
            var l = document.createElement('link');
            l.rel = 'prefetch';
            l.as = 'image';
            l.href = data.images[0].url;
            document.head.appendChild(l);
          }
        } catch (e) {}
      });
    }

    // Custom inputs (debounced canvas update)
    var _redrawTimer = null;
    function debouncedUpdate() {
      clearTimeout(_redrawTimer);
      _redrawTimer = setTimeout(update, 16);
    }
    if (els.customName) {
      els.customName.addEventListener('input', function () {
        var clean = els.customName.value.replace(/[^A-Za-zÜüÁáÉéÍíÓóÚúÀàÈèÌìÒòÙùÖöÑñÇç\s\-\.]/g, '');
        if (clean !== els.customName.value) els.customName.value = clean;
        state.customName = clean.toUpperCase();
        els.customName.classList.remove('is-error');
        if (state.customName) gotoSlide('customize');
        debouncedUpdate();
      });
    }
    if (els.customNumber) {
      els.customNumber.addEventListener('input', function () {
        var clean = els.customNumber.value.replace(/\D/g, '').slice(0, 2);
        if (clean !== els.customNumber.value) els.customNumber.value = clean;
        state.customNumber = clean;
        els.customNumber.classList.remove('is-error');
        if (state.customNumber) gotoSlide('customize');
        debouncedUpdate();
      });
    }

    // Gallery — query DOM live since thumbs/slides may be rebuilt
    function gotoSlide(idx) {
      section.querySelectorAll('.gfc-kit__slide').forEach(function (s) {
        s.classList.toggle('is-active', s.dataset.slideIndex === String(idx));
      });
      section.querySelectorAll('.gfc-kit__thumb').forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.thumbIndex === String(idx));
      });
    }
    section.querySelectorAll('.gfc-kit__thumb').forEach(function (t) {
      t.addEventListener('click', function () { gotoSlide(t.dataset.thumbIndex); });
    });
    var currentImageIdx = 0;
    function imageCount() {
      return section.querySelectorAll('.gfc-kit__slide:not(.gfc-kit__slide--customize)').length;
    }
    if (els.navPrev) els.navPrev.addEventListener('click', function () {
      var n = imageCount(); if (!n) return;
      currentImageIdx = (currentImageIdx - 1 + n) % n;
      gotoSlide(currentImageIdx);
    });
    if (els.navNext) els.navNext.addEventListener('click', function () {
      var n = imageCount(); if (!n) return;
      currentImageIdx = (currentImageIdx + 1) % n;
      gotoSlide(currentImageIdx);
    });

    // Canvas overlay — fully configurable via data-attrs + per-badge overrides
    function getActiveBadgeOverrides() {
      var checked = section.querySelector('input[name="gfc-badge"]:checked');
      if (!checked) return {};
      return {
        font: checked.dataset.fontFamily || '',
        nameColor: checked.dataset.nameColor || '',
        nameStroke: checked.dataset.nameStroke || '',
        numberColor: checked.dataset.numberColor || '',
        numberStroke: checked.dataset.numberStroke || ''
      };
    }

    function readPct(attr, fallback) {
      var v = parseFloat(els.canvas && els.canvas.dataset[attr]);
      return isNaN(v) ? fallback : v;
    }

    function applyTransform(text) {
      var t = (els.canvas && els.canvas.dataset.textTransform) || 'uppercase';
      if (t === 'uppercase') return String(text || '').toUpperCase();
      if (t === 'lowercase') return String(text || '').toLowerCase();
      return String(text || '');
    }

    function applyCanvasPerspective() {
      if (!els.canvas) return;
      var d = els.canvas.dataset;
      var depth = parseFloat(d.perspectiveDepth) || 1500;
      var rx = parseFloat(d.perspectiveRotateX) || 0;
      var ry = parseFloat(d.perspectiveRotateY) || 0;
      var skewX = parseFloat(d.skewX) || 0;
      var skewY = parseFloat(d.skewY) || 0;
      els.canvas.style.transform = 'perspective(' + depth + 'px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) skew(' + skewX + 'deg, ' + skewY + 'deg)';
      els.canvas.style.transformOrigin = 'center center';
    }

    function redrawCanvas() {
      if (!els.canvas || !els.canvasBase) return;
      var img = els.canvasBase;
      var canvas = els.canvas;
      var rect = img.getBoundingClientRect();
      if (!rect.width) return;

      var dpr = window.devicePixelRatio || 1;
      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;
      canvas.style.width = rect.width + 'px';
      canvas.style.height = rect.height + 'px';

      var ctx = canvas.getContext('2d');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, rect.width, rect.height);

      applyCanvasPerspective();

      var rawName = state.mode === 'custom' ? state.customName : state.mode === 'player' ? state.playerName : '';
      var rawNum = state.mode === 'custom' ? state.customNumber : state.mode === 'player' ? state.playerNumber : '';
      var name = applyTransform(rawName);
      var num = String(rawNum || '');

      var overrides = getActiveBadgeOverrides();
      var defaultFont = canvas.dataset.defaultFont || 'Impact, Arial Narrow, sans-serif';
      var font = overrides.font || defaultFont;

      // Precarga de fuente (como en home): si la familia no está lista, cargar y redibujar.
      // Sin esto el dorsal se pinta con la tipografía fallback (LALIGAPlayers/Montilivi tarde).
      var fam = String(font).split(',')[0].replace(/["']/g, '').trim();
      if (fam && document.fonts && document.fonts.check && !document.fonts.check('24px "' + fam + '"')) {
        redrawCanvas._pending = redrawCanvas._pending || {};
        if (!redrawCanvas._pending[fam]) {
          redrawCanvas._pending[fam] = true;
          // weight 400: muchas fuentes (LALIGAPlayers) solo tienen un peso; cargar 900 falla.
          document.fonts.load('400 100px "' + fam + '"')
            .then(function () { redrawCanvas._pending[fam] = false; redrawCanvas(); })
            .catch(function () { redrawCanvas._pending[fam] = false; });
        }
      }

      var nameX = readPct('nameXPct', 50) / 100;
      var nameY = readPct('nameYPct', 32) / 100;
      var nameSize = readPct('nameSizePct', 7) / 100;
      var numX = readPct('numberXPct', 50) / 100;
      var numY = readPct('numberYPct', 52) / 100;
      var numSize = readPct('numberSizePct', 18) / 100;
      var strokePct = readPct('strokeWidthPct', 8) / 100;
      var letterSpPct = readPct('letterSpacingPct', 0) / 100;
      var badgeForArc = section.querySelector('input[name="gfc-badge"]:checked');
      var badgeArc = badgeForArc ? (parseFloat(badgeForArc.dataset.arcDeg) || 0) : 0;
      var arcDeg = badgeArc || parseFloat(canvas.dataset.nameArcDeg) || 0;
      // Overrides tamaño/borde: prioridad EQUIPACIÓN (ficha, por handle) → PEGAT → global.
      var _eNameSize = parseFloat(canvas.dataset.eqNameSizePct) || 0;
      var _eNumSize = parseFloat(canvas.dataset.eqNumberSizePct) || 0;
      var _eStroke = parseFloat(canvas.dataset.eqStrokeWidthPct) || 0;
      var _bNameSize = badgeForArc ? parseFloat(badgeForArc.dataset.nameSizePct) : 0;
      var _bNumSize = badgeForArc ? parseFloat(badgeForArc.dataset.numberSizePct) : 0;
      var _bStroke = badgeForArc ? parseFloat(badgeForArc.dataset.strokeWidthPct) : 0;
      if (_eNameSize > 0) nameSize = _eNameSize / 100; else if (_bNameSize > 0) nameSize = _bNameSize / 100;
      if (_eNumSize > 0) numSize = _eNumSize / 100; else if (_bNumSize > 0) numSize = _bNumSize / 100;
      if (_eStroke > 0) strokePct = _eStroke / 100; else if (_bStroke > 0) strokePct = _bStroke / 100;
      // Override de posición: equipación → pegat ('usar posición propia').
      var _posSrc = (canvas.dataset.eqPosOverride === 'true')
        ? { nx: canvas.dataset.eqNameXPct, ny: canvas.dataset.eqNameYPct, ux: canvas.dataset.eqNumberXPct, uy: canvas.dataset.eqNumberYPct }
        : (badgeForArc && badgeForArc.dataset.posOverride === 'true')
        ? { nx: badgeForArc.dataset.nameXPct, ny: badgeForArc.dataset.nameYPct, ux: badgeForArc.dataset.numberXPct, uy: badgeForArc.dataset.numberYPct }
        : null;
      if (_posSrc) {
        var _nx = parseFloat(_posSrc.nx), _ny = parseFloat(_posSrc.ny), _ux = parseFloat(_posSrc.ux), _uy = parseFloat(_posSrc.uy);
        if (!isNaN(_nx)) nameX = _nx / 100;
        if (!isNaN(_ny)) nameY = _ny / 100;
        if (!isNaN(_ux)) numX = _ux / 100;
        if (!isNaN(_uy)) numY = _uy / 100;
      }
      var nameRotDeg = parseFloat(canvas.dataset.nameRotationDeg) || 0;
      var numRotDeg = parseFloat(canvas.dataset.numberRotationDeg) || 0;
      // Override de grosor: equipación → pegat → global.
      var nameWeight = canvas.dataset.eqNameWeight || (badgeForArc && badgeForArc.dataset.nameWeight) || canvas.dataset.nameWeight || '700';
      var numberWeight = canvas.dataset.eqNumberWeight || (badgeForArc && badgeForArc.dataset.numberWeight) || canvas.dataset.numberWeight || '700';
      var italic = canvas.dataset.italic === 'true';

      // Color: equipación → pegat → global.
      var nameColor = canvas.dataset.eqNameColor || overrides.nameColor || canvas.dataset.nameColor;
      var nameStroke = canvas.dataset.eqNameStroke || overrides.nameStroke || canvas.dataset.nameStroke;
      var numberColor = canvas.dataset.eqNumberColor || overrides.numberColor || canvas.dataset.numberColor;
      var numberStroke = canvas.dataset.eqNumberStroke || overrides.numberStroke || canvas.dataset.numberStroke;

      var skipText = !!state.linkedProduct;
      if (!skipText) {
        if (name) {
          if (Math.abs(arcDeg) > 0.5) {
            drawTextArc(ctx, name, rect.width * nameX, rect.height * nameY, rect.width * nameSize, nameColor, nameStroke, strokePct, font, nameWeight, italic, arcDeg);
          } else {
            drawText(ctx, name, rect.width * nameX, rect.height * nameY, rect.width * nameSize, nameColor, nameStroke, strokePct, font, letterSpPct * rect.width, nameWeight, italic, nameRotDeg);
          }
        }
        if (num) {
          drawText(ctx, num, rect.width * numX, rect.height * numY, rect.width * numSize, numberColor, numberStroke, strokePct, font, 0, numberWeight, italic, numRotDeg);
        }
      }

      var badgeInput = section.querySelector('input[name="gfc-badge"]:checked');
      if (badgeInput && badgeInput.dataset.overlayImage) {
        drawBadgeOverlay(ctx, rect, badgeInput);
      }
    }

    var _overlayCache = {};
    function drawBadgeOverlay(ctx, rect, input) {
      var url = input.dataset.overlayImage;
      var xPct = parseFloat(input.dataset.overlayXPct) || 80;
      var yPct = parseFloat(input.dataset.overlayYPct) || 25;
      var sizePct = parseFloat(input.dataset.overlaySizePct) || 12;

      var img = _overlayCache[url];
      if (!img) {
        img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = url;
        _overlayCache[url] = img;
        img.onload = function () { redrawCanvas(); };
        return;
      }
      if (!img.complete || !img.naturalWidth) return;

      var size = rect.width * (sizePct / 100);
      var ratio = img.naturalHeight / img.naturalWidth;
      var w = size;
      var h = size * ratio;
      var x = rect.width * (xPct / 100) - w / 2;
      var y = rect.height * (yPct / 100) - h / 2;
      ctx.drawImage(img, x, y, w, h);
    }

    function buildFontString(weight, italic, size, font) {
      return (italic ? 'italic ' : '') + (weight || '700') + ' ' + size + 'px ' + font;
    }

    function drawText(ctx, text, x, y, fontSize, fill, stroke, strokePct, font, letterSpacing, weight, italic, rotationDeg) {
      ctx.save();
      ctx.font = buildFontString(weight, italic, fontSize, font);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.lineWidth = Math.max(2, fontSize * (strokePct || 0.08));
      ctx.lineJoin = 'round';
      ctx.miterLimit = 2;

      if (rotationDeg) {
        ctx.translate(x, y);
        ctx.rotate(rotationDeg * Math.PI / 180);
        x = 0; y = 0;
      }

      if (letterSpacing && letterSpacing > 0) {
        var letters = String(text).split('');
        var totalWidth = 0;
        letters.forEach(function (ch) { totalWidth += ctx.measureText(ch).width; });
        totalWidth += letterSpacing * (letters.length - 1);
        var cursor = x - totalWidth / 2;
        letters.forEach(function (ch) {
          var w = ctx.measureText(ch).width;
          var cx = cursor + w / 2;
          if (stroke) { ctx.strokeStyle = stroke; ctx.strokeText(ch, cx, y); }
          if (fill) { ctx.fillStyle = fill; ctx.fillText(ch, cx, y); }
          cursor += w + letterSpacing;
        });
      } else {
        if (stroke) { ctx.strokeStyle = stroke; ctx.strokeText(text, x, y); }
        if (fill) { ctx.fillStyle = fill; ctx.fillText(text, x, y); }
      }
      ctx.restore();
    }

    // Geometría idéntica a la del home (gfc-home-kit.js), que funciona.
    function drawTextArc(ctx, text, cx, cy, fontSize, fill, stroke, strokePct, font, weight, italic, arcDeg) {
      ctx.save();
      ctx.font = buildFontString(weight, italic, fontSize, font);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.lineWidth = Math.max(2, fontSize * (strokePct || 0.08));
      ctx.lineJoin = 'round';

      var chars = String(text).split('');
      var widths = chars.map(function (c) { return ctx.measureText(c).width; });
      var totalW = widths.reduce(function (a, b) { return a + b; }, 0);
      var arcRad = (arcDeg || 0) * Math.PI / 180;
      if (Math.abs(arcRad) < 0.001) {
        if (stroke) { ctx.strokeStyle = stroke; ctx.strokeText(text, cx, cy); }
        if (fill) { ctx.fillStyle = fill; ctx.fillText(text, cx, cy); }
        ctx.restore(); return;
      }
      var radius = totalW / Math.abs(arcRad);
      var sign = arcRad >= 0 ? 1 : -1;
      ctx.translate(cx, cy + radius * sign);
      var angleStart = -Math.abs(arcRad) / 2;
      var accW = 0;
      for (var i = 0; i < chars.length; i++) {
        var w = widths[i];
        var charAngle = (angleStart + (accW + w / 2) / radius) * sign;
        accW += w;
        ctx.save();
        ctx.rotate(charAngle);
        ctx.translate(0, -radius * sign);
        if (stroke) { ctx.strokeStyle = stroke; ctx.strokeText(chars[i], 0, 0); }
        if (fill) { ctx.fillStyle = fill; ctx.fillText(chars[i], 0, 0); }
        ctx.restore();
      }
      ctx.restore();
    }

    if (els.canvasBase) {
      if (els.canvasBase.complete) redrawCanvas();
      else els.canvasBase.addEventListener('load', redrawCanvas);
      window.addEventListener('resize', redrawCanvas);
      if (window.ResizeObserver) {
        new ResizeObserver(redrawCanvas).observe(els.canvasBase);
      }
    }

    // Precarga de fuentes del canvas (badges + default) a su peso real (700) y redibujo al
    // estar listas. Sin esto el nombre/dorsal se pinta con fuente fallback hasta el primer
    // repintado (p.ej. abrir DevTools). Montilivi tiene un fichero por peso → cargar 700.
    if (document.fonts && document.fonts.load) {
      var _fams = new Set();
      section.querySelectorAll('input[name="gfc-badge"]').forEach(function (b) {
        var f = b.dataset.fontFamily;
        if (f && f.trim()) _fams.add(f.trim().replace(/^['"]|['"]$/g, ''));
      });
      var _df = els.canvas && els.canvas.dataset.defaultFont;
      if (_df) _df.split(',').forEach(function (f) {
        f = f.trim().replace(/^['"]|['"]$/g, ''); if (f) _fams.add(f);
      });
      var _loads = [];
      Array.from(_fams).forEach(function (f) {
        _loads.push(document.fonts.load('700 100px "' + f + '"').catch(function () {}));
        _loads.push(document.fonts.load('400 100px "' + f + '"').catch(function () {}));
      });
      Promise.all(_loads).then(redrawCanvas);
      if (document.fonts.ready) document.fonts.ready.then(redrawCanvas);
    }

    // Sticky ATC (mobile only)
    if (els.sentinel && els.form && window.IntersectionObserver) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          els.form.classList.toggle('is-floating', !e.isIntersecting);
        });
      }, { rootMargin: '-100px 0px 0px 0px' });
      observer.observe(els.sentinel);
    }

    // ATC submit — AJAX with cart drawer refresh + visual validation
    els.form.addEventListener('submit', function (e) {
      e.preventDefault();
      // Validation: visual error markers instead of alert.
      // Modo player sin selección = sin serigrafía (compra camiseta base, sin error).
      if (state.mode === 'custom') {
        // Cal almenys nom O número (qualsevol dels dos cobra estampació, com a home).
        if (!state.customName && !state.customNumber) {
          if (els.customName) els.customName.classList.add('is-error');
          if (els.customNumber) els.customNumber.classList.add('is-error');
          return;
        }
        if (els.customName) els.customName.classList.remove('is-error');
        if (els.customNumber) els.customNumber.classList.remove('is-error');
      }
      if (!state.size) return;

      var btn = els.atc;
      btn.classList.add('is-loading');
      btn.disabled = true;

      // Propiedades de la camiseta (los inputs name="properties[...]" del form).
      var props = {};
      els.form.querySelectorAll('[name^="properties["]').forEach(function (inp) {
        var m = inp.name.match(/^properties\[(.+)\]$/);
        if (m && inp.value !== '') props[m[1]] = inp.value;
      });
      // Bundle id para enlazar la camiseta con sus recargos (y poder ocultarlos/sincronizarlos en carrito).
      var bundleId = 'gfc-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);
      props['_bundle'] = bundleId;

      var items = [{ id: parseInt(els.variantInput.value, 10), quantity: 1, properties: props }];

      // Recargo personalización (nom/dorsal) → línea extra real SOLO si hay personalización
      // real (jugador elegido o nombre+dorsal), igual que el precio mostrado.
      var hasPersonalization = (state.mode === 'player' && state.playerName) || (state.mode === 'custom' && (state.customName || state.customNumber));
      if (hasPersonalization && cfg.nameFeeVariant) {
        items.push({ id: cfg.nameFeeVariant, quantity: 1, properties: { '_bundle': bundleId, '_fee': 'estampacio' } });
      }
      // Recargo pegat de competició → línea extra real (variante segons el badge).
      var badgeFee = (state.badge && state.badge !== 'none' && cfg.badgeFees) ? cfg.badgeFees[state.badge] : null;
      if (badgeFee) {
        items.push({ id: badgeFee, quantity: 1, properties: { '_bundle': bundleId, '_fee': 'pegat' } });
      }

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble,header' })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status >= 400 || data.errors) {
          throw new Error(data.description || 'Error añadiendo al carrito');
        }
        // Personalización también en NOTAS del pedido (nota del carrito → nota del pedido).
        try {
          var _nl = [];
          Object.keys(props).forEach(function (k) {
            if (k === '_fee') return;
            if (props[k] !== '' && props[k] != null) _nl.push(k + ': ' + props[k]);
          });
          if (_nl.length) {
            var noteLine = _nl.join('\n');
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
              var prev = (c && c.note) ? String(c.note) : '';
              var next = prev ? (prev + '\n\n' + noteLine) : noteLine;
              fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: next }) });
            }).catch(function () {});
          }
        } catch (e) {}
        // Detail con shape compatible Horizon:
        // - component-cart-items: event.detail.data.sections[sectionId]
        // - cart-drawer: event.detail.resource.item_count
        var detail = { resource: data, data: { sections: data.sections } };
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail }));
        document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: detail }));

        // Abrir drawer (Horizon)
        var drawer = document.querySelector('cart-drawer-component, #cart-drawer, [data-cart-drawer]');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else if (drawer && typeof drawer.showDialog === 'function') drawer.showDialog();
        else if (drawer && typeof drawer.show === 'function') drawer.show();

        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        els.atcText.textContent = '✓ Añadido';
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.disabled = false;
          els.atcText.textContent = cfg.atcText;
        }, 1500);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        els.atcText.textContent = cfg.atcText;
        alert(err.message || 'No se pudo añadir al carrito');
      });
    });

    function parseSection(html, selector) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector(selector);
    }

    // Pre-select tab based on current product handle
    function preselectFromUrl() {
      var path = location.pathname.split('/');
      var idx = path.indexOf('products');
      var currentHandle = idx >= 0 ? (path[idx + 1] || '').split('?')[0] : '';
      if (!currentHandle) return;

      var fireTab = function (name) {
        for (var i = 0; i < els.tabs.length; i++) {
          if (els.tabs[i].dataset.tab === name) { els.tabs[i].click(); return; }
        }
      };

      if (cfg.kits.custom && currentHandle === cfg.kits.custom.handle) {
        fireTab('custom');
        return;
      }
      if (cfg.kits.player && currentHandle === cfg.kits.player.handle) {
        fireTab('player');
        return;
      }
      // Match a player option's linked product
      if (els.playerSelect) {
        for (var j = 0; j < els.playerSelect.options.length; j++) {
          var opt = els.playerSelect.options[j];
          if (!opt.dataset.linked) continue;
          try {
            var linked = JSON.parse(opt.dataset.linked);
            if (linked.handle === currentHandle) {
              fireTab('player');
              els.playerSelect.value = opt.value;
              els.playerSelect.dispatchEvent(new Event('change'));
              return;
            }
          } catch (e) {}
        }
      }
    }

    // Restore custom name/number/badge from URL params (share design support)
    function restoreFromUrlParams() {
      var sp = new URLSearchParams(location.search);
      var n = sp.get('n'), num = sp.get('num'), badge = sp.get('badge');
      if (n || num) {
        var customTab = section.querySelector('.gfc-kit__tab[data-tab="custom"]');
        if (customTab) customTab.click();
        if (els.customName && n) { els.customName.value = n; state.customName = n; }
        if (els.customNumber && num) { els.customNumber.value = num; state.customNumber = num; }
      }
      if (badge && badge !== 'none') {
        var b = section.querySelector('input[name="gfc-badge"][value="' + CSS.escape(badge) + '"]');
        if (b) { b.checked = true; b.dispatchEvent(new Event('change')); }
      }
    }

    // Init: sincronizar modo con el tab activo del markup (PDP arranca en 'player').
    var _activeTab = section.querySelector('.gfc-kit__tab.is-active');
    if (_activeTab && _activeTab.dataset.tab) state.mode = _activeTab.dataset.tab;
    // Init: sincronizar badge marcado (forloop.first) → precio refleja el pegat por defecto.
    var _checkedBadge = section.querySelector('input[name="gfc-badge"]:checked');
    if (_checkedBadge) {
      state.badge = _checkedBadge.value;
      state.badgePrice = parseInt(_checkedBadge.dataset.price, 10) || 0;
      try { state.badgeLinkedProduct = _checkedBadge.dataset.linked ? JSON.parse(_checkedBadge.dataset.linked) : null; } catch (e) {}
    }

    update();
    preselectFromUrl();
    restoreFromUrlParams();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
